module.exports = __webpack_public_path__ + "fonts/85c4305a/aboutme-glyphs.eot";